// src/lib/api/core/companies.js
import { supabase } from '../../supabase'
import { withErrorHandling, createSuccessResponse } from '../shared/errors'
import { logger } from '../../logger'

/**
 * Get all companies
 * Migrated from supabaseApi.js lines 572-590
 */
const _getCompanies = async () => {
  logger.supabaseApi('getCompanies called')
  const { data, error } = await supabase
    .from('companies')
    .select('*')
    .order('created_at', { ascending: false })
  
  if (error) {
    console.error('[supabaseApi] Error in getCompanies query:', error)
    throw error
  }
  
  logger.supabaseApi('getCompanies success, found', data?.length || 0, 'companies')
  return createSuccessResponse(data || [])
}

export const getCompanies = withErrorHandling(_getCompanies, 'fetch companies', 'companies')